import {DetailsField} from '@/components/ui/details-atoms/DetailsAtoms'
import {formatDate, formatLocaleDate} from '@/dayjs'
import {useTranslation} from '@/translations/i18n'
import {Grid} from '@/components/ui/grid-atoms/GridAtoms'
import {Text} from '@/components/ui/text/Text'
import {capitalize} from '@/utilities/helpers'

export const MedicalReportDetailsHeading = ({
    date,
    createdByFullName,
    specializationName,
    projectCode,
    projectStartDate,
    isDocument,
    documentDate,
    documentNote,
    isAggregatedPrint
}: {
    date: string
    createdByFullName: string | null
    specializationName: string | null
    projectCode?: number
    projectStartDate?: string | null
    isDocument?: boolean
    documentDate?: Date
    documentNote?: string
    isAggregatedPrint?: boolean
}) => {
    const {t} = useTranslation()

    return (
        <>
            <Grid columns={3} gap={3}>
                {isAggregatedPrint ? (
                    <DetailsField>
                        <Text weight="500" size="textMd">
                            {t('medical_records:report_date')}
                        </Text>
                        <Text size="textSm" palette="neutral" shade="500">
                            {capitalize(formatLocaleDate(date, 'MMMM'))}
                        </Text>
                    </DetailsField>
                ) : (
                    <DetailsField>
                        <Text weight="500" size="textMd">
                            {t('medical_records:report_date')}
                        </Text>
                        <Text size="textSm" palette="neutral" shade="500">
                            {formatDate(date, 'DD/MM/YYYY')}
                        </Text>
                    </DetailsField>
                )}
                <DetailsField>
                    <Text weight="500" size="textMd">
                        {createdByFullName}
                    </Text>
                    <Text size="textSm" palette="neutral" shade="500">
                        {specializationName}
                    </Text>
                </DetailsField>

                {!isAggregatedPrint && (
                    <DetailsField>
                        <Text weight="500" size="textMd">
                            PRI
                        </Text>
                        <Text size="textSm" palette="neutral" shade="500">
                            {projectCode && projectStartDate
                                ? t('medical_records:code_date', {
                                      code: projectCode,
                                      date: formatDate(projectStartDate, 'DD/MM/YYYY')
                                  })
                                : t('commons:none')}
                        </Text>
                    </DetailsField>
                )}

                {isDocument && documentDate && documentNote && (
                    <>
                        <DetailsField>
                            <Text weight="500" size="textMd">
                                {t('medical_records:document_date')}
                            </Text>
                            <Text size="textSm" palette="neutral" shade="500">
                                {formatDate(documentDate, 'DD/MM/YYYY')}
                            </Text>
                        </DetailsField>
                        <DetailsField>
                            <Text weight="500" size="textMd">
                                {t('commons:notes')}
                            </Text>
                            <Text size="textSm" palette="neutral" shade="500">
                                {documentNote}
                            </Text>
                        </DetailsField>
                    </>
                )}
            </Grid>
        </>
    )
}
